import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutBrand } from './components/AboutBrand';
import { Products } from './components/Products';
import { Categories } from './components/Categories';
import { Benefits } from './components/Benefits';
import { FeaturedEbooks } from './components/FeaturedEbooks';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-blanco text-texto font-sans selection:bg-rosa selection:text-texto" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <AboutBrand data-id="element-4" />
        <Products data-id="element-5" />
        <Categories data-id="element-6" />
        <Benefits data-id="element-7" />
        <FeaturedEbooks data-id="element-8" />
        <Testimonials data-id="element-9" />
        <FAQ data-id="element-10" />
        <CTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}